<h1 mat-dialog-title>{{data.title}}</h1>
<div mat-dialog-content>
  <p>{{data.message}}</p>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onConfirmClick()">Sim!</button>
  <button mat-button (click)="onNoClick()">Não</button>
</div>
